import { Countries, SHOW_ENGAGEMENT_FOR_COUNTRIES_LIST } from '../constants';

export const isShowEngagementBasedOnCountry = (
  country: string | null | undefined,
): boolean => {
  return SHOW_ENGAGEMENT_FOR_COUNTRIES_LIST.includes(
    (country as Countries) ?? '',
  );
};
